import request from '@/axios'
import { useI18n } from '@/hooks/web/useI18n'
import { ElNotification } from 'element-plus'

const { t } = useI18n()

export const CONTROLLER_PATH = '/api/Information'
// 後台通用設定 / 分租通用設定 API 現在改由 WebConfigController 提供
const WEB_CONFIG_CONTROLLER_PATH = '/api/WebConfig'

/**預設設定 */
export const fetchInfo = () => {
  return request.get<{
    Routes: any[]
    Company: Company
    Permissions: string[]
    WebSettings: WebSettings
    Store: StoreInformation
  }>({ url: `${CONTROLLER_PATH}` })
}

/**群組下拉清單（tenantId 僅供 SuperAdmin 依所選租戶篩選，TenantAdmin 由後端自動以自己租戶為準）*/
export const fetchRoleOptions = (params?: { tenantId?: string }) => {
  return request.get({ url: `${CONTROLLER_PATH}/FetchRoleOptions`, params })
}


//============== 後台用戶 查詢條件

/**後台用戶 查詢條件 */
export const fetchUserQuerySettings = (page: string, params?: any) => {
  return request
    .get<{
      List: {
        Id: number
        Method: string
        SetData: string | boolean
        Type: string
      }[]
    }>({ url: `${CONTROLLER_PATH}/FetchUserQuerySettings/${page}`, params })
    .then((res) => {
      ;(res.data.List || []).forEach((x) => {
        if (x.SetData === 'true') {
          x.SetData = true
        } else if (x.SetData === 'false') {
          x.SetData = false
        }
      })
      return res
    })
}

/**後台用戶 更新條件 */
export const updateUserQuerySettings = (
  page: string,
  data: {
    method?: string
    type: string
    data: any
  }
) => {
  return request
    .post({ url: `${CONTROLLER_PATH}/UpdateUserQuerySettings/${page}`, data })
    .then((result) => {
      // const { t } = useI18n()
      //ElNotification({
      //  type: 'success',
        // message: t('common.editSuccess')
       // message: '修改成功'
    //  })
      return result
    })
}

/**後臺用戶 刪除條件 */
export const delUserQuerySettings = (ids: number[]) => {
  return request
    .delete({ url: `${CONTROLLER_PATH}/DelUserQuerySettings`, data: ids })
    .then((result) => {
      // const { t } = useI18n()
      ElNotification({
        type: 'success',
        // message: t('common.delSuccess')
        message: '刪除成功'
      })
      return result
    })
}

//============== 後台通用設定 查詢條件

/**後台通用設定 查詢條件 */
export const fetchWebConfig = (category: string, params?: any) => {
  return request.get<{
    List: {
      Id: number
      Category: string
      WebTarget: string
      Parameter: string
      SetValue: string
      Memo: string
    }[]
  }>({ url: `${WEB_CONFIG_CONTROLLER_PATH}/FetchWebConfig/${category}`, params })
}

/**後台用戶 更新條件 */
export const updateWebConfig = (
  category: string,
  data: {
    Parameter: string
    SetValue: string
    WebTarget?: string
  }[]
) => {
  return request
    .post({
      url: `${WEB_CONFIG_CONTROLLER_PATH}/UpdateFetchWebConfig/${category}`,
      data: {
        item: data
      }
    })
    .then((result) => {
      // const { t } = useI18n()
      ElNotification({
        type: 'success',
        // message: t('common.editSuccess')
        message: '修改成功'
      })
      return result
    })
}

//============== 分租(Tenant) 通用設定 查詢條件（讀寫租戶自己的 DB，非主檔）

/**分租通用設定 查詢條件 */
export const fetchTenantWebConfig = (category: string, params?: any) => {
  return request.get<{
    List: {
      Id: number
      Category: string
      WebTarget: string
      Parameter: string
      SetValue: string
      Memo: string
    }[]
  }>({ url: `${WEB_CONFIG_CONTROLLER_PATH}/FetchTenantWebConfig/${category}`, params })
}

/**分租通用設定 更新條件 */
export const updateTenantWebConfig = (
  category: string,
  data: {
    Parameter: string
    SetValue: string
    WebTarget?: string
  }[]
) => {
  return request
    .post({
      url: `${WEB_CONFIG_CONTROLLER_PATH}/UpdateTenantWebConfig/${category}`,
      data: {
        item: data
      }
    })
    .then((result) => {
      ElNotification({
        type: 'success',
        message: '修改成功'
      })
      return result
    })
}

//============== 編輯器
export const fetchEditorToken = () => {
  return request.get<{
    Data: {
      Access_token: string
      UserName: string
    }
  }>({ url: `${CONTROLLER_PATH}/FetchEditorToken` })
}

/**測試 SMTP 連線並發送測試郵件 */
export const testSmtpConnection = (data: { TestEmail: string }) => {
  return request
    .post<{
      Success: boolean
      Message: string
      Details?: string
    }>({
      url: `api/Email/SendTestEmail`,
      data
    })
    .then((result) => {
      if (result.data.Success) {
        ElNotification({
          type: 'success',
          title: 'SMTP 測試成功',
          message: result.data.Message || '測試郵件已成功發送'
        })
      } else {
        ElNotification({
          type: 'error',
          title: 'SMTP 測試失敗',
          message: result.data.Message || '連線測試失敗'
        })
      }
      return result
    })
    .catch((error) => {
      ElNotification({
        type: 'error',
        title: 'SMTP 測試錯誤',
        message: error.response?.data?.message || error.message || '網路連線錯誤'
      })
      throw error
    })
}



//===============================================
export interface Company {
  ComName: string
  CompanyUrl: string
  AdminCompanyDescription: string
  AdminCompanyLogo: string
  AdminCompanyLoginLogo: string
  /** 後台登入驗證碼設定：三選一（不使用 / RecaptchaV3 / Turnstile） */
  AdminCaptcha: {
    AdminCaptchaProvider: string
    AdminRecaptchaV3SiteKey: string
    AdminRecaptchaV3ScoreThreshold: string
    AdminTurnstileSiteKey: string
  }
  IsDesignMode: boolean
  EnabledLanguage: boolean
}

export interface WebSettings {
  /**語系 */
  Language: Language[]
  Setting: CompanySetting
}

export interface Language {
  Code: string
  Country: string
}

export interface CompanySetting {
  FileServerUrl: string
  FileApiPath: string
  FilePath: string
  FileVerificationCode: string
}

export interface StoreInfo {
  Id: number
  Name: string
  /** JSON 字串，格式: {"Status":"Y","PermissionScope":"Y"} */
  LinebotStatus: string
}

export interface StoreInformation {
  Info: StoreInfo
  IsHeadquarters: boolean
}
